export default __webpack_public_path__ + "static/media/imgDarkEn7.1e3bcb82.png";